var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "caselist" },
    _vm._l(_vm.caseList, function (case_item, case_item_index) {
      return _c(
        "li",
        {
          key: case_item_index,
          on: {
            click: function ($event) {
              return _vm.pathGo({
                name: "case",
                params: case_item,
                id: case_item.caseId,
              })
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "award", class: "rarity" + (case_item_index + 2) },
            [
              _c("div", { staticClass: "placeholder" }),
              _c("div", { staticClass: "blank-icon" }),
              _c("div", { staticClass: "itemimg" }, [
                _c("img", {
                  attrs: { src: _vm.$imgfilter(case_item.casePic) },
                }),
              ]),
              _c("c-svg", {
                staticClass: "itembg",
                attrs: { src: "itembg.svg", fill: "rgba(0, 0, 0, 0.2)" },
              }),
              _c("div", { staticClass: "item-name-con" }, [
                _c("div", { staticClass: "item-name" }, [
                  _c("div", { staticClass: "weapon-name" }, [
                    _vm._v(" " + _vm._s(case_item.caseName) + " "),
                  ]),
                  _c("div", { staticClass: "skin-name" }, [
                    _vm._v("今日邀请 "),
                    _c("span", [_vm._v(_vm._s(case_item.conditionVal))]),
                    _vm._v(" 位好友"),
                  ]),
                ]),
                _c("div", { staticClass: "block" }),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "case-price-btn" }, [
            _vm.totalInviteCount < case_item.conditionVal
              ? _c("span", { staticClass: "case-price-btn-content" }, [
                  _vm._v(
                    "未达成(" +
                      _vm._s(_vm.totalInviteCount) +
                      "/" +
                      _vm._s(case_item.conditionVal) +
                      " )"
                  ),
                ])
              : _c("span", { staticClass: "case-price-btn-content" }, [
                  _vm._v("立即开启"),
                ]),
          ]),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }